export default function ServicesHero() {
  return (
    <section className="relative min-h-screen w-full flex items-center justify-center overflow-hidden bg-[#09090B]">
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/c9f90b4ef3a75eff765f90294ad6b836.jpg"
          alt=""
          className="w-full h-full object-cover object-top opacity-20"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#09090B]/70 via-[#09090B]/50 to-[#09090B]" />
      </div>

      {/* Grid overlay */}
      <div
        className="absolute inset-0 opacity-4"
        style={{
          backgroundImage: "linear-gradient(rgba(255,255,255,0.06) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.06) 1px, transparent 1px)",
          backgroundSize: "60px 60px",
        }}
      />

      <div className="relative z-10 w-full max-w-5xl mx-auto px-6 pt-36 pb-24 text-center">
        <div className="inline-flex items-center gap-2 border border-[#4ADE80]/30 rounded-full px-4 py-1.5 mb-8">
          <span className="w-1.5 h-1.5 rounded-full bg-[#4ADE80] animate-pulse inline-block" />
          <span className="text-xs font-semibold uppercase tracking-widest text-[#4ADE80]">Our Services</span>
        </div>

        <h1
          className="text-5xl md:text-7xl font-extrabold text-white leading-tight tracking-tight mb-6"
          style={{ fontFamily: "'Space Grotesk', sans-serif" }}
        >
          AI Systems Built for{" "}
          <span className="text-[#4ADE80]">Stability</span> and Scale
        </h1>

        <p
          className="text-lg md:text-xl text-white/50 max-w-2xl mx-auto leading-relaxed"
          style={{ fontFamily: "'Inter', sans-serif" }}
        >
          Our services are designed to replace operational chaos with structured, reliable systems—built
          in layers, designed to compound over time.
        </p>
      </div>
    </section>
  );
}
